import { cn } from "../../lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("tw-animate-pulse tw-rounded-md tw-bg-gray-200 dark:tw-bg-gray-700", className)}
      {...props}
    />
  );
}

export { Skeleton }; 